/**
 * Query variables for the Devices tab's Stock section.
 *
 * The section used to drain every page and slice the result locally; it now asks the server for
 * exactly the page it renders. `limit` is always sent because the server's own default page size
 * is larger than this table's.
 */

export interface InventoryQueryInput {
  query?: string;
  limit: number;
  offset: number;
}

export function inventoryQueryInput(searchQuery: string, page: number, pageSize: number): InventoryQueryInput {
  // A blank search must be absent rather than an empty string: the server treats any present
  // `query` as a filter to apply.
  const trimmed = searchQuery.trim();
  return {
    ...(trimmed ? { query: trimmed } : {}),
    limit: pageSize,
    offset: Math.max(0, page - 1) * pageSize,
  };
}

export function inventoryTotalPages(totalCount: number, pageSize: number): number {
  return Math.max(1, Math.ceil(totalCount / pageSize));
}

/**
 * The page the Stock section should actually show, given how many there now are.
 *
 * Assigning the last device on the last page shrinks the list under the user: the count drops,
 * the page they are on stops existing, and nothing in the pager moves them — it only knows the
 * page it was handed. Clamping keeps the request and the pager on a page that exists.
 */
export function clampInventoryPage(page: number, totalPages: number): number {
  return Math.min(Math.max(1, page), Math.max(1, totalPages));
}
